import React, {FC, useEffect, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import { useAppSelector } from '../hooks';
import BookingService from '../api/BookingService';
// @ts-ignore
import styles from './SuccessMessage.module.css';

interface successMessageProps {
    link:string
}

const SuccessMessage:FC<successMessageProps> = ({link}) => {
    const {t} = useTranslation();
    const needInvoice = useAppSelector((state) => { return state.customerDetails.needInvoice; });
    const startDate = useAppSelector((state) => { return state.delivery.startDate!; });
    const invoiceEmail = useAppSelector((state) => { return state.invoiceDetails.invoiceEmail; });
    const [checkfrontIFrameUrl, setCheckfrontIFrameUrl] = useState<string | null>(null);

    async function fetchIFrame() {
        if (!checkfrontIFrameUrl) {
            const url = await BookingService.getCheckfrontIFrameUrl();
            setTimeout(() => {
                console.log(url);
                setCheckfrontIFrameUrl(url);
            }, 1000);
        }
    }

    useEffect(() => {
        if (needInvoice) {
            fetchIFrame();
        }
    });

    return (
        <div>
            {!needInvoice &&
                <div>
                    <h1>{t("successBookingMessage")}</h1>
                    <div>{t("successBookingMessageRedirect")} <a href={link}>{t("successBookingMessageLinkAnchor")}</a> </div>
                </div>
            }
            {/* If they filled out the invoice form, then no redirect is required */}
            {needInvoice &&
                <div>
                    <h2>{t('invoiceSuccess.heading')}</h2>
                    <p>{t('invoiceSuccess.sendEmailTo', {date: startDate.toLocaleDateString()})} <a href={"mailto:"
                        + invoiceEmail}>{invoiceEmail}</a>.</p>
                    <p>{t('invoiceSuccess.paymentDeferred')}</p>
                    <p>{t('invoiceSuccess.payAlready')} <a href={link}>{t('invoiceSuccess.thisLink')}</a>.</p>
                    {checkfrontIFrameUrl !== null && <div>
                        <h3>{t("invoiceSuccess.overview")}:</h3>
                        <iframe
                            src={checkfrontIFrameUrl}
                            className={styles.checkfrontIFrame}
                        />
                    </div>
                    }
                </div>
            }
        </div>
    );
};

export default SuccessMessage;
